import React, { FC } from 'react';

import {
	EvBodyDefault,
	EvChips,
	EvFlexColumn,
	EvHeadingSmall,
	EvSelectNew
} from '@evinced-private/ui-common';

import {
	EMAIL_AUTOMATION_IDS,
	EMAIL_SETTINGS_DESCRIPTION_ID,
	EMAIL_SETTINGS_TITLE_ID
} from './EmailSettings.constants';
import { EMAIL_LABELS } from './EmailSettings.labels';
import { useEmailRecipients } from './useEmailRecipients';

import './EmailSettings.scss';

export const EmailSettings: FC = () => {
	const {
		recipients,
		initialOptions,
		loadUserOptions,
		handleRecipientSelect,
		handleRemoveRecipient
	} = useEmailRecipients();

	return (
		<div className="email-settings-separator">
			<EvFlexColumn
				gap="XLARGE"
				margin={['XLARGE', 'NONE', 'NONE', 'NONE']}
				padding={['XLARGE', 'NONE', 'NONE', 'NONE']}
				role="group"
				ariaLabelledby={EMAIL_SETTINGS_TITLE_ID}
				ariaDescribedby={EMAIL_SETTINGS_DESCRIPTION_ID}
				dataAutomationId={EMAIL_AUTOMATION_IDS.SECTION}
			>
				<EvFlexColumn gap="SMALL">
					<EvHeadingSmall as="h3" id={EMAIL_SETTINGS_TITLE_ID}>
						{EMAIL_LABELS.SECTION_TITLE}
					</EvHeadingSmall>
					<EvBodyDefault as="p" id={EMAIL_SETTINGS_DESCRIPTION_ID}>
						{EMAIL_LABELS.SECTION_DESCRIPTION}
					</EvBodyDefault>
				</EvFlexColumn>
				<EvFlexColumn width="320px">
					<EvSelectNew
						id={EMAIL_AUTOMATION_IDS.RECIPIENTS_SELECT}
						label={EMAIL_LABELS.SELECT_LABEL}
						placeholder={EMAIL_LABELS.SELECT_PLACEHOLDER}
						options={initialOptions}
						isSearchable
						loadOptions={loadUserOptions}
						debounceValue={300}
						selectedValue={null}
						onSelectChange={handleRecipientSelect}
						ariaLabel={EMAIL_LABELS.SELECT_LABEL}
						dataAutomationId={EMAIL_AUTOMATION_IDS.RECIPIENTS_SELECT}
					/>
				</EvFlexColumn>
				{recipients.length > 0 && (
					<EvFlexColumn gap="SMALL">
						<EvBodyDefault as="p" dataAutomationId={EMAIL_AUTOMATION_IDS.ADDED_RECIPIENTS_TITLE}>
							{EMAIL_LABELS.ADDED_RECIPIENTS_TITLE}
						</EvBodyDefault>
						<EvChips
							chips={recipients}
							onClick={handleRemoveRecipient}
							wrap="WRAP"
							dataAutomationId={EMAIL_AUTOMATION_IDS.RECIPIENTS_CHIPS}
						/>
					</EvFlexColumn>
				)}
			</EvFlexColumn>
		</div>
	);
};
